var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPollBarsInactiveLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#DFE5F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_poll_inactive_light)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.0306 27) scale(1.22449)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#181D24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 11,
    width: 4,
    height: 10,
    rx: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.25,
    y: 6,
    width: 4,
    height: 15,
    rx: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 2,
    width: 4,
    height: 19,
    rx: 1.8
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_poll_inactive_light"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 25.7143,
    fill: "white",
    transform: "translate(24.5 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollBarsInactiveLight);
export default __webpack_public_path__ + "static/media/PollBarsInactiveLight.ed2e1da55f418fa8c29dc3ce0dbd414a.svg";
export { ForwardRef as ReactComponent };